import { Spinner } from '@change/ds-core-ui';

import { useKnownAvailableParams } from '@change-corgi/core-react/router';

import { withPrefetchedData } from '#src/shared/prefetch';

import {
	prefetchPageContext,
	StarterDashboardV2PageContextProvider,
	StarterDashboardV2PageNotificationManagerProvider,
} from '#src/app/pages/starterDashboardV2/pageContext';
import type { StarterDashboardV2PagePrefetchedDataProps } from '#src/app/pages/starterDashboardV2/pageContext';
import { DynamicModulesProvider } from '#src/app/pages/starterDashboardV2/shared/contexts';

import { Layout } from '../layout';

import { StarterDashboardV2ErrorHandler } from './ErrorHandler';
import { ExportHandler } from './ExportHandler';

export const StarterDashboardV2 = withPrefetchedData(
	function StarterDashboardV2({ prefetchedData }: StarterDashboardV2PagePrefetchedDataProps) {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		return (
			<StarterDashboardV2PageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				errorHandler={StarterDashboardV2ErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<StarterDashboardV2PageNotificationManagerProvider>
					<ExportHandler>
						<DynamicModulesProvider>
							<Layout />
						</DynamicModulesProvider>
					</ExportHandler>
				</StarterDashboardV2PageNotificationManagerProvider>
			</StarterDashboardV2PageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
	},
);
